export const isIframe = (): boolean => {
  // window.top is potentially blocked due to cross-origin restrictions, so we must wrap in try/catch
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};
